'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLoadB = function IoLoadB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 12.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-7.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v7.5z m-2.5 12.5c1.4 0 2.5 1.1 2.5 2.5v7.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-7.5c0-1.4 1.1-2.5 2.5-2.5z m15-7.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-7.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h7.5z m-22.5 0c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-7.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h7.5z m14.5-1c-0.9 0.9-2.5 0.9-3.5 0-0.9-1-0.9-2.7 0-3.6l5.3-5.2c1-1 2.6-1 3.5 0 1 0.9 1 2.5 0 3.5z m-10.5 7c0.9 1 0.9 2.6 0 3.6l-5.3 5.2c-1 1-2.6 1-3.5 0s-1-2.5 0-3.5l5.2-5.3c0.9-0.9 2.6-0.9 3.6 0z m15.8 5.3c1 1 1 2.6 0 3.5s-2.5 1-3.5 0l-5.3-5.3c-0.9-0.9-0.9-2.5 0-3.5s2.6-0.9 3.5 0z m-15.8-15.8c0.9 0.9 0.9 2.5 0 3.5s-2.7 0.9-3.6 0l-5.2-5.3c-1-1-1-2.6 0-3.5s2.5-1 3.5 0z' })
        )
    );
};

exports.default = IoLoadB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/load-b.js
// module id = 2336
// module chunks = 0